<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("CRUD.newInfo", [$t("AccountQacenter.ObjectName")]) }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("AccountQacenter.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <!-- 主题 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                $t("AccountQacenter.Fields.title") + $t("Global.colon")
                }}
                <Required :show="true" mode="new" />
              </v-col>
              <v-col cols="9" md="7">
                <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('AccountQacenter.Fields.title')"
                        rules="required"
                >
                  <v-text-field
                          single-line
                          v-model="title"
                          :error-messages="errors"
                  >
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- 内容 -->
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                $t("AccountQacenter.Fields.content") + $t("Global.colon")
                }}
                <Required :show="true" mode="new" />
              </v-col>
              <v-col cols="9" md="7" >
                <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('AccountQacenter.Fields.content')"
                        rules="required"
                >
                  <v-textarea
                          outlined
                          v-model="text"
                          :error-messages="errors"
                  >
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-textarea>
                </ValidationProvider>



              </v-col>
            </v-row>
          </ValidationObserver>
          <!-- 图片 -->
          <v-row align="center">
            <v-col cols="3" class="font-weight-bold text-right">
              {{
              $t("AccountQacenter.Fields.img") + $t("Global.colon")
              }}
            </v-col>
            <v-col cols="9" md="7" >
              <v-card
                      v-if="qa_album && qa_album.length > 0"
                      style="width: 240px"
              >
                <v-carousel hide-delimiters cycle height="200">
                  <v-carousel-item
                          v-for="(item, i) in qa_album"
                          :key="i"
                          :src="item"
                          @click.stop="$showFullscreenImages(qa_album, i)"
                  >
                    <v-tooltip right v-if="item">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="secondary"
                                class="pa-2 float-right"
                                @click.stop="removeFromImages(i)"
                        >
                          fa-times
                        </v-icon>
                      </template>
                      <span> {{ $t("Material.delImg") }}</span>
                    </v-tooltip>
                  </v-carousel-item>
                </v-carousel>
              </v-card>
              <v-file-input
                      ref="qa_imgs_file"
                      show-size
                      counter
                      small-chips
                      multiple
                      suffix
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('Material.imgsPlaceholder')"
                      :rules="imgsRules"
                      v-model="qa_imgs_file"
              >
              </v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                      outlined
                      color="secondary"
                      class="elevation-1"
                      block
                      @click="
                      $emit('input', null);
                      $emit('mode', null);
                    "
              >
                <v-icon small class="pe-1">fa-times</v-icon>
                {{ $t("CRUD.backToList", [$t("AccountQacenter.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col
                    cols="12"
            >
              <v-btn
                      color="success"
                      block
                      @click="submit()"
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("AccountQacenter.Fields.submit") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider  } from "vee-validate";
import Required from "@/components/plugins/Required";
import AccountQacenter from "@/api/account_qacenter";
import Files from "@/api/files"

export default {
  name: "AccountQacenterNewQa",

  props: ["value", "accountUser", "accountInfo"],

  components: {
    ValidationObserver,
    ValidationProvider,
    Required
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    title:'',
    text:'',
    qa_album: [],
    qa_imgs_file: [],
    serverErrors: [],
    imgsRules: [
      (value) =>
              !value ||
              value.filter((v) => v.size >= 5000000).length == 0 ||
              i18n.t("Material.Import.imgsHint"),
    ],
  }),

  methods: {
    removeFromImages(i) {
      this.qa_album.splice(i, 1);
      this.qa_imgs_file.splice(i, 1);
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
              async function (result) {
                if (result) {
                  let answerSaveData = {
                    enterprise_id: this.accountInfo.enterprise_id,
                    account_id: this.accountInfo.account_id,
                    title: this.title,
                    text: this.text,
                    img_path: [],
                    account_user_name: this.accountUser.name,
                    user_id: this.accountUser.id
                  };
                  if (this.qa_imgs_file.length > 0 ) {
                    let imgResponse = await Files.imagesUpload(this.qa_imgs_file, false, 'accounts_qa');
                    if (imgResponse.data.status.isOK()) {
                      imgResponse.data.data.forEach((column) => {
                        answerSaveData.img_path.push(column.img_name)
                      })
                      AccountQacenter.newQaSave(answerSaveData)
                              .then((response) => {
                                if (response.data.status.isOK()) {
                                  this.$emit("mode", null);
                                  this.$emit("input", null);
                                }
                              })
                    }
                  }else {
                    AccountQacenter.newQaSave(answerSaveData)
                    .then((response) => {
                      if (response.data.status.isOK()) {
                        this.$emit("mode", null);
                        this.$emit("input", null);
                      }
                    })
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                } else {
                  this.$store.dispatch("fullscreenLoadingStop");
                }
              }.bind(this)
      );
    },
    resetForm() {
      this.title = '';
      this.text = '';
      this.qa_album = [];
      this.qa_imgs_file = [];
    }
  },
  watch: {
    value: {
      immediate: false, //初始赋值不调用
      handler() {
        this.$scrollTop(); //返回顶部
        this.resetForm(); //清除表单
        this.$refs.observer.reset(); //清除表单验证错误
      },
    },
    qa_imgs_file: {
      handler() {
        if (this.qa_imgs_file) {
          this.qa_album = [];
          this.qa_imgs_file.forEach((img, i) => {
            var reader = new FileReader();
            reader.readAsDataURL(img);
            let that = this;
            reader.onload = function () {
              that.qa_album.splice(i, 0, this.result);
            };
          });
        } else {
          this.qa_album = [];
        }
      },
    },
  },
};
</script>